export default {
  // Loading Page
  loading: {
    title: "Préparation de votre espace de travail",
    message: "Veuillez patienter pendant que nous préparons votre tableau de bord..."
  },
  // Sidebar Navigation
  sidebar: {
    dashboard: "Tableau de bord",
    recommendations: "Recommandations",
    organizationDesign: "Conception d'organisation",
    talentPool: "Réservoir de talents",
    reports: "Rapports",
    notifications: "Notifications",
    switchOrg: "Changer d'organisation"
  },
  // Talent Pool / Users Page
  talentPool: {
    relationshipAddedSuccessfully: "Relation ajoutée avec succès",
    relationshipRemovedSuccessfully: "Relation supprimée avec succès",
    relationshipSavedSuccessfully: "Relation sauvegardée avec succès",
    profileCard: "Carte de profil",
    viewOptions: {
      plan: "Plan",
      hierarchy: "Hiérarchie",
      network: "Réseau"
    },
    searchPlaceholder: "Rechercher des utilisateurs...",
    networkSearchPlaceholder: "Rechercher le réseau...",
    hierarchySearchPlaceholder: "Rechercher la hiérarchie...",
    // KVDR Notifications
    kvdrNotifications: {
      create: "Créer",
      roleCreatedSuccessfully: "Rôle créé avec succès",
      delete: "Supprimer",
      roleDeletedSuccessfully: "Rôle supprimé avec succès",
      addProfile: "Ajouter le profil",
      profileAddedSuccessfully: "Profil ajouté avec succès",
      removeProfile: "Supprimer le profil",
      profileRemovedSuccessfully: "Profil supprimé avec succès",
      roleUpdate: "Mise à jour du rôle",
      updatedSuccessfully: "Mis à jour avec succès",
      profileUpdate: "Mise à jour du profil",
      profileUpdatedSuccessfully: "Profil mis à jour avec succès"
    },
  },
  // Settings Help Page
  settingsHelp: {
    frequentlyAskedQuestions: "Questions Fréquemment Posées",
    question1: "Comment gérer les paramètres de mon organisation ?",
    question2: "Comment puis-je inviter de nouveaux membres à mon organisation ?",
    question3: "Quels sont les différents rôles et permissions des utilisateurs ?",
    question4: "Comment personnaliser l'identité de marque de mon organisation ?",
    helpText: "Ceci est un texte d'aide d'exemple. Veuillez contacter le support pour une assistance spécifique concernant les paramètres et la configuration de votre organisation."
  },
  // Create Organization
  createOrganization: {
    organizationName: "Nom de l'organisation",
    organizationUsername: "Nom d'utilisateur de l'organisation",
    website: "Site web",
    workEmail: "Email professionnel",
    location: "Localisation",
    organizationType: "Type d'organisation",
    primaryThemeColor: "Couleur de thème principale",
    secondaryThemeColor: "Couleur de thème secondaire",
    about: "À propos",
    saveChanges: "Sauvegarder les modifications",
    usernameExists: "Ce nom d'utilisateur existe déjà",
    usernameAvailable: "Ce nom d'utilisateur est disponible",
    organizationTypeOptions: {
      business: "Entreprise",
      academic: "Académique",
      recruiter: "Recruteur"
    },
    logo: {
      adjustTitle: "Ajuster le logo de l'organisation",
      save: "Sauvegarder",
      uploadButton: "Télécharger le logo",
      incorrectFileType: "Type de fichier incorrect",
      incorrectFileTypeText: "Veuillez télécharger un type de fichier image pris en charge, par ex. jpg, png, etc.",
      fileSizeExceeded: "Taille de fichier image dépassée",
      fileSizeExceededText: "La taille de l'image de profil doit être inférieure à 1 Mo."
    }
  },

  // Main Organizations List
  main: {
    select: "Sélectionner",
    acceptInvitation: "Accepter l'invitation",
    noOrganizationFound: "Aucune organisation trouvée !",
    noOrganizationSubtext: "Créez d'abord votre propre organisation.",
    createOrganization: "Créer une organisation",
    myOrganizations: "Mes Organisations",
    viewAllOrganizations: "Voir toutes les organisations",
    pendingInvitation: "En attente"
  },

  // Organization Dashboard
  organization: {
    welcomeBack: "Bon retour ! 👋",
    setupComplete: "Configuration terminée !",
    setupProgress: "Configuration : {step} sur 4",
    copyLink: "Copier le lien",
    linkCopied: "Lien copié",
    criticalRoles: "Rôles critiques",
    talentPool: "Réservoir de talents",
    integrations: "Intégrations",
    onboarding: "Intégration",
    activeCandidates: "Candidats actifs",
    connectedApps: "Applications connectées",
    pendingOnboards: "Intégrations en attente",
    kvdrReportsCenter: "Centre de rapports KVDR",
    kvdrReportsDescription: "Plongez dans vos rapports de données visuelles clés et obtenez des informations critiques.",
    exploreReports: "Explorer les rapports >",
    talentPoolExplorer: "Explorateur de réservoir de talents",
    talentPoolDescription: "Découvrez, analysez et gérez vos meilleurs talents avec des informations complètes.",
    exploreTalentPool: "Explorer le réservoir de talents >",
    thisMonth: "ce mois-ci",
    goToOnboarding: "Aller à l'intégration"
  },

  // Reports
  reports: {
    title: "Rapports",
    nineCellMatrix: "Matrice à neuf cellules",
    xyPlot: "Graphique XY",
    talentScoreCard: "Carte de score des talents",
    emptyReports: "Rapports vides",
    createKVDRFirst: "Créez d'abord un KVDR et planifiez pour voir les rapports",
    // XY Plot specific
    xAxis: "Axe X",
    yAxis: "Axe Y",
    bubbleSize: "Taille de bulle",
    loadingChart: "Chargement du graphique...",
    howToReadChart: "Comment lire ce graphique",
    positioning: "Positionnement",
    horizontalPosition: "La position horizontale montre",
    verticalPosition: "La position verticale montre",
    bubbleRepresentation: "Représentation des bulles",
    eachBubbleRepresents: "Chaque bulle représente un employé",
    sizeIndicates: "La taille indique",
    quadrants: "Quadrants",
    topLeft: "Haut-Gauche",
    topRight: "Haut-Droite",
    bottomLeft: "Bas-Gauche",
    bottomRight: "Bas-Droite",
    low: "Faible",
    high: "Élevé",
    interaction: "Interaction",
    hoverOverBubble: "Survolez une bulle",
    revealsDetailedMetrics: "Révèle des métriques détaillées pour cet employé",
    colorCoding: "Codage couleur",
    differentColorsHelp: "Différentes couleurs aident à distinguer les employés",
    // Nine Cell Matrix specific
    nineCellMatrixTitle: "Catégorisation des employés par matrice à neuf cellules",
    methodologyDescription: "Méthodologie standardisée basée sur le score de performance et la préparation à la succession",
    loading: "Chargement...",
    preparingMatrix: "Préparation de la matrice à neuf cellules...",
    noDataAvailable: "Aucune donnée disponible",
    employeeAssessmentRequired: "Les données d'évaluation des employés sont requises pour afficher la matrice à neuf cellules.",
    successionReadiness: "Préparation à la succession",
    performanceScore: "Score de performance",
    bargain: "AFFAIRE",
    bind: "LIER",
    backup: "SAUVEGARDE",
    onTrack: "SUR LA BONNE VOIE",
    boost: "BOOST",
    build: "CONSTRUIRE",
    bootBarter: "BOOT/TROC",
    employees: "Employés",
    methodologyTitle: "Méthodologie de la matrice à neuf cellules",
    methodologySubtitle: "Catégorisation standardisée des employés basée sur les calculs de score de performance et de préparation à la succession.",
    calculationMethod: "Méthode de calcul",
    performanceScoreFormula: "Score de performance (P)",
    performanceScoreCalculation: "P = 0,6 × Performance + 0,4 × Évaluation",
    performanceScoreNote: "Les scores bruts (-1 à 1,5) sont normalisés à l'échelle 0-100",
    successionReadinessFormula: "Préparation à la succession (R)",
    successionReadinessCalculation: "R = 0,5 × Succession + 0,3 × Adéquation + 0,2 × Score des années",
    successionReadinessNote: "Les scores bruts (-1 à 1,5) sont normalisés à l'échelle 0-100",
    yearsScore: "Score des années",
    yearsScoreCalculation: "Si Années ≥ 3 : 100, sinon : (Années / 3) × 100",
    yearsScoreNote: "Utilise actuellement 2 ans par défaut (configurable)",
    cellCategories: "Catégories de cellules",
    backupDescription: "Haute performance, Haute succession",
    boostDescription: "Performance moyenne, Haute succession",
    bindDescription: "Haute/Moyenne succession, Performance faible/moyenne",
    onTrackDescription: "Performance moyenne/faible, Succession moyenne/faible",
    buildDescription: "Performance moyenne, Succession faible",
    bargainDescription: "Performance faible, Haute succession",
    bootBarterDescription: "Haute performance, Succession faible",
    // Talent Score Card specific
    criteria: "Critères",
    talent: "TALENT",
    role: "RÔLE",
    remarks: "REMARQUES",
    weightage: "Pondération",
    good: "Bon (8-10)",
    average: "Moyen (5-7)",
    poor: "Mauvais (1-4)",
    notApplicable: "Non applicable"
  },

  // Talent Pool
  talentPool: {
    title: "Réservoir de talents",
    reviewRequest: "Demande de révision",
    // Main talent pool
    noPendingRequest: "Aucune demande en attente trouvée",
    importFrom: "Importer depuis",
    uploadExcel: "télécharger excel",
    uploadResumes: "télécharger currículum",
    uploadResumesTooltip: "Importer des currículums (PDF)",
    orHRIS: "ou HRIS",
    pendingRequest: "Demande en attente",
    allUsers: "Tous les utilisateurs",
    addNewEmployee: "Ajouter une nouvelle carte employé",
    // Table headers
    name: "Nom",
    email: "E-mail",
    maxRole: "Rôle max",
    relationships: "Relations",
    action: "Action",
    // User search
    searchUser: "Rechercher un utilisateur",
    userNotFound: "Utilisateur non trouvé.",
    // Relationship management
    member: "Membre",
    relationship: "Relation",
    addRelation: "Ajouter une relation",
    removeRelationship: "Supprimer la relation",
    // Add employee form
    firstName: "Prénom",
    lastName: "Nom de famille",
    roleTitle: "Titre du rôle",
    save: "Sauvegarder",
    // Profile card
    profileCard: "Carte de profil",
    // Import
    importFromExcel: "Importer depuis Excel"
  },

  // Users
  users: {
    title: "Utilisateurs",
    manageUsers: "Gérer les utilisateurs",
    // User Recommendations
    talentRecommendations: "Recommandations de talents",
    recommendationsDescription: "Basé sur votre évaluation KVDR, voici des recommandations personnalisées pour votre organisation",
    viewActivePlans: "Voir les plans actifs",
    // Recommendation Cards
    fitmentPlan: "Plan d'adaptation",
    fitmentPlanDescription: "Intégration des personnes dans leurs rôles.",
    fitmentPlanContent: "Intégration des personnes dans leurs rôles. Cartographie du bon talent vers les bons rôles avec des indicateurs d'adaptation",
    developmentPlan: "Plan de développement",
    developmentPlanDescription: "Apprentissage alimenté par l'IA avec ALEX",
    developmentPlanContent: "Création de plans d'apprentissage avec ALEX Parcours d'apprentissage personnalisés pour augmenter la valeur des talents avec des compétences.",
    successionPlanning: "Planification de la succession",
    successionPlanningDescription: "Promouvoir et soutenir la croissance de carrière",
    successionPlanningContent: "Promouvoir et soutenir la croissance de carrière Plans de coaching pour la préparation aux compétences et au temps pour le prochain rôle.",
    // Benefits Lists
    roadToRole: "Route vers votre rôle (Voyage)",
    skillProfiling: "Profilage des compétences",
    learningCredits: "Crédits d'apprentissage",
    marketRewards: "Récompenses du marché",
    customLearningPaths: "Parcours d'apprentissage personnalisés",
    aiAssistedValidation: "Validation assistée par IA",
    progressTracking: "Suivi des progrès avec des points d'expérience (XPs)",
    interactiveExercises: "Exercices interactifs",
    appraisalIndicators: "Indicateurs d'évaluation 360°",
    goalSettingMentorship: "Définition d'objectifs et mentorat",
    behaviouralCoaching: "Coaching comportemental et plans",
    managedCareerGuidance: "Conseils de carrière gérés",
    // Action Buttons
    onboard: "Intégrer",
    activate: "Activer",
    promote: "Promouvoir",
    // Progress Section
    talentCapabilitySnapshot: "Aperçu des capacités des talents",
    lastUpdated: "Dernière mise à jour : Aujourd'hui",
    refresh: "Actualiser",
    // Score Labels
    industryLeader: "Leader de l'industrie",
    highPerforming: "Haute performance",
    competitive: "Compétitif",
    developing: "En développement",
    foundationBuilding: "Construction de fondations",
    // Notifications
    alexActivated: "ALEX activé",
    alexActivatedText: "Votre assistant d'apprentissage IA est prêt à vous aider !",
    coachingRequestSent: "Demande de coaching envoyée",
    coachingRequestSentText: "Un coach vous contactera bientôt !",
    rewardsMarketplace: "Marketplace des récompenses",
    rewardsMarketplaceText: "Explorer les récompenses et avantages disponibles !"
  },

  // Integrations
  integrations: {
    title: "Intégrations",
    manageIntegrations: "Gérer les intégrations"
  },

  // Admins
  admins: {
    title: "Administrateurs",
    manageAdmins: "Gérer les administrateurs"
  }
};
